import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { content } from "./content";
import { extra } from "./extra";

const LangContext = createContext(null);
const KEY = "indushub_lang";
const merged = { fr: { ...content.fr, ...extra.fr }, en: { ...content.en, ...extra.en } };

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => (localStorage.getItem(KEY) === "en" ? "en" : "fr"));

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
    document.title = content[lang].meta.title;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);
  const value = useMemo(() => ({ lang, t: merged[lang], toggle }), [lang, toggle]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
